
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ModuleType, DatabaseMessage } from "./types";
import { transformDatabaseMessage } from "./utils";

export const useAutomatedMessagesQuery = (moduleType: ModuleType, userId?: string) => {
  return useQuery({
    queryKey: ['automated-messages', moduleType, userId],
    queryFn: async () => {
      if (!userId) return [];
      
      // First, get the automated messages
      const { data: messages, error: messagesError } = await supabase
        .from('automated_messages')
        .select('*')
        .eq('module_type', moduleType)
        .eq('user_id', userId)
        .order('send_time');

      if (messagesError) {
        console.error('Error fetching automated messages:', messagesError);
        throw messagesError;
      }

      // Then get metrics for each message
      const messagesWithMetrics = await Promise.all(
        (messages || []).map(async (message) => {
          const { data: metrics, error: metricsError } = await supabase
            .from('automated_message_metrics')
            .select('*')
            .eq('message_id', message.id);

          if (metricsError) {
            console.error('Error fetching metrics for message:', message.id, metricsError);
          }

          return {
            ...message,
            automated_message_metrics: metrics || []
          };
        })
      );

      return messagesWithMetrics.map((item: any) => transformDatabaseMessage(item as DatabaseMessage));
    },
    enabled: !!userId,
  });
};
